"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _subscribeFirebase2 = require("./subscribeFirebase");

var _subscribeFirebase3 = _interopRequireDefault(_subscribeFirebase2);

var subscribe = function subscribe(state, currentOptions, onCancel) {
  return function (localBinding) {
    var firebaseRefs = state.firebaseRefs;
    var firebaseListeners = state.firebaseListeners;
    var firebasePopulated = state.firebasePopulated;
    var store = state.store;
    var appName = state.appName;

    var _subscribeFirebase = (0, _subscribeFirebase3["default"])(localBinding, currentOptions[localBinding], {
      store: store,
      onCancel: onCancel,
      name: appName
    });

    var ref = _subscribeFirebase.ref;
    var listeners = _subscribeFirebase.listeners;
    var populated = _subscribeFirebase.populated;

    firebaseRefs[localBinding] = ref;
    firebaseListeners[localBinding] = listeners;
    firebasePopulated[localBinding] = populated;
  };
};

exports["default"] = subscribe;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/refire/lib/syncFirebase/subscribe.js
// module id = 1001
// module chunks = 0